import axios from "./axios";
import { formTypeAlias } from "./utils"

import { formatSections } from "@shared/case-entities/utils";

export class FormsPreviewServ {
    static async fetchForms({ type }) {
        let formError = false;
        const formType = formTypeAlias[type] ?? type;
        try {
            const { data } = await axios.get(`/case/additional-forms/${formType}`);
            console.log("step-1",data);
            return data;
        } catch (error) {
            formError = {error: true, errorMessage: error?.response?.data?.detail};
            console.log(error, "[+]Form is already submitted");
            return formError;
        }
    }
    static async saveForm() {
        let isSaved = false;
        try {
            await axios.post("/case/additional-forms/submit");
            isSaved = true;
        } catch (error) {
            console.log(error, "[+]error while submitting the form");
        }
        return isSaved;
    }
    static async saveSection({ type, data }) {
        let sectionSaved = false;
        const formType = formTypeAlias[type] ?? type;
        const url = `/case/additional-forms/${formType}`;
        try {
            const sections = formatSections({ data }).sections[0]
            await axios.post(url, sections);
            sectionSaved = true;
        } catch (error) {
            console.log(error, "[+] error in save form section");
            sectionSaved = false;
        }
        return sectionSaved;
    }
    static async validateToken({ token }) {
        try {
            const { data } = await axios.post("/form-auth/validate", {
                link_identifier: token,
            });
            return data;
        } catch (error) {
            console.log(error, "[+]failed validate token");
        }
    }
    static async fetchRefreshToken(token) {
        const url = `/form-auth/token`;
        try {
            let response = await axios.post(url, { link_identifier: token });
            return response.data.access_token;
        } catch (error) {
            console.error(error);
            throw new Error("Refresh token failed from server!");
        }
    }
}
